import { Component, Inject, Input, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { CustomerService, CustomersMenuGet } from '@app/services/customer.service';

@Component({
    selector: 'tt-customers-menu-functions',
    templateUrl: './customers-menu-functions.component.html',
    styleUrls: ['./customers-menu-functions.component.css'],
})
export class CustomersMenuFunctionsComponent {
    @Input()
    public params?: CustomersMenuGet;

    public deleting = false;

    constructor(
        private customer: CustomerService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {}

    public openLink(link: string) {
        window.open(link);
    }

    public async deleteCustomer() {
        if (!this.params) return;

        try {
            this.deleting = true;

            const response = await this.customer.deleteCustomer(this.params);
            console.log('response :>> ', response);

            if (!!response && typeof response === 'object' && 'validation' in response && typeof response.validation === 'boolean' && response.validation === true) {
                //do nothing
            } else {
                this.navigator?.back();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.deleting = false;
        }
    }
}
